import api from 'src/utils/api';
import * as log from 'loglevel';
import {
  CLEAR_SURVEY,
  NEXT_SCREEN,
  PREVIOUS_SCREEN,
  FETCH_PROFILE_SURVEY_DATA,
  FETCH_PROFILE_SURVEY_DATA_SUCCESS,
  FETCH_PROFILE_SURVEY_DATA_FAILURE,
  UPDATE_PROFILE_SURVEY_BASICS_SUCCESS,
  UPDATE_PROFILE_SURVEY_BASICS_FAILURE,
  ADD_PROFILE_SURVEY_INTERESTS_SUCCESS,
  ADD_PROFILE_SURVEY_INTERESTS_FAILURE,
  DELETE_PROFILE_SURVEY_INTEREST_SUCCESS,
  DELETE_PROFILE_SURVEY_INTEREST_FAILURE,
  ADD_PROFILE_SURVEY_CONDITION_SUCCESS,
  ADD_PROFILE_SURVEY_CONDITION_FAILURE,
  DELETE_PROFILE_SURVEY_CONDITION_SUCCESS,
  DELETE_PROFILE_SURVEY_CONDITION_FAILURE,
  UPDATE_PROFILE_SURVEY_CONDITION_SUCCESS,
  UPDATE_PROFILE_SURVEY_CONDITION_FAILURE,
  ADD_PROFILE_SURVEY_TREATMENT_SUCCESS,
  ADD_PROFILE_SURVEY_TREATMENT_FAILURE,
  DELETE_PROFILE_SURVEY_TREATMENT_SUCCESS,
  DELETE_PROFILE_SURVEY_TREATMENT_FAILURE,
  UPDATE_PROFILE_SURVEY_TREATMENT_SUCCESS,
  UPDATE_PROFILE_SURVEY_TREATMENT_FAILURE,
  FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS,
  FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_SUCCESS,
  FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_FAILURE,
} from './actionTypes';
import { setAlert } from 'src/typescript/components/alert/actions';

export const clearSurvey = () => {
  return {
    type: CLEAR_SURVEY,
  };
};

export const nextScreen = (nextScreen) => {
  return {
    type: NEXT_SCREEN,
    nextScreen,
  };
};

export const previousScreen = () => {
  return {
    type: PREVIOUS_SCREEN,
  };
};

export const fetchProfile = () => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_PROFILE_SURVEY_DATA });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const response = await api.get(`private/users/${currentUser.userId}/profile`);
      dispatch({
        type: FETCH_PROFILE_SURVEY_DATA_SUCCESS,
        data: response.data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: FETCH_PROFILE_SURVEY_DATA_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateProfileBasics = (basicData) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      // Wait for the endpoint to return the latest basics data and use them in the state
      const { data } = await api.put(`private/users/${currentUser.userId}/profile/basics`, {
        'basic-data': basicData,
      });
      dispatch({
        type: UPDATE_PROFILE_SURVEY_BASICS_SUCCESS,
        data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: UPDATE_PROFILE_SURVEY_BASICS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const addInterests = (interestList) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data: { interests } } = await api.post(`private/users/${currentUser.userId}/profile`, {
        'profile-data': {
          interests: interestList,
        },
      });
      dispatch({
        type: ADD_PROFILE_SURVEY_INTERESTS_SUCCESS,
        interests,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: ADD_PROFILE_SURVEY_INTERESTS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const deleteInterest = (id) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      await api.del(`private/users/${currentUser.userId}/profile/interests/${id}`);
      dispatch({
        type: DELETE_PROFILE_SURVEY_INTEREST_SUCCESS,
        id,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: DELETE_PROFILE_SURVEY_INTEREST_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const addConditions = (conditions) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await api.post(`private/users/${currentUser.userId}/profile`, {
        'profile-data': { conditions },
      });
      dispatch({
        type: ADD_PROFILE_SURVEY_CONDITION_SUCCESS,
        condition: data.conditions[0],
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: ADD_PROFILE_SURVEY_CONDITION_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const deleteCondition = (id) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      await api.del(`private/users/${currentUser.userId}/profile/conditions/${id}`);
      dispatch({
        type: DELETE_PROFILE_SURVEY_CONDITION_SUCCESS,
        id,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: DELETE_PROFILE_SURVEY_CONDITION_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateCondition = (id, conditionData) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await api.put(`private/users/${currentUser.userId}/profile/conditions/${id}`, {
        condition: conditionData,
      });
      dispatch({
        type: UPDATE_PROFILE_SURVEY_CONDITION_SUCCESS,
        condition: data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: UPDATE_PROFILE_SURVEY_CONDITION_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const addTreatment = (id, conditionEntityId, treatment) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await api.post(`private/users/${currentUser.userId}/profile`, {
        'profile-data': {
          conditions: [
            {
              entityId: conditionEntityId,
              treatments: [treatment],
            },
          ],
        },
      });
      dispatch({
        type: ADD_PROFILE_SURVEY_TREATMENT_SUCCESS,
        id,
        treatment: data.conditions[0].treatments[0],
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: ADD_PROFILE_SURVEY_TREATMENT_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const deleteTreatment = (id, conditionId) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      await api.del(`private/users/${currentUser.userId}/profile/conditions/${conditionId}/treatments/${id}`);

      dispatch({
        type: DELETE_PROFILE_SURVEY_TREATMENT_SUCCESS,
        id,
        conditionId,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: DELETE_PROFILE_SURVEY_TREATMENT_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const updateTreatment = (id, conditionId, treatmentData) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const { data } = await api.put(`private/users/${currentUser.userId}/profile/conditions/${conditionId}/treatments/${id}`, {
        'treatment': treatmentData,
      });
      dispatch({
        type: UPDATE_PROFILE_SURVEY_TREATMENT_SUCCESS,
        conditionId,
        id,
        data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: UPDATE_PROFILE_SURVEY_TREATMENT_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

async function fetchCommunityTopEntities(communityId) {
  const { data } = await api.getPublic(`community-top-tags/${communityId}`);
  return data.filter(entity => entity.rank === 1 && entity.concept === 'CONDITION');
}

function fetchAllCommunityTopEntities(userCommunityIds) {
  return Promise.all(userCommunityIds.map(fetchCommunityTopEntities));
}

export const fetchConditionSuggestions = () => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS });
    try {
      const state = getState();
      const userCommunityIds = state.context.currentUser.followedCommunities.map(x => x.communityId);
      if (!userCommunityIds) return;
      const conditions = await fetchAllCommunityTopEntities(userCommunityIds);

      const suggestedConditions = conditions.filter(({length}) => length > 0).flat();

      dispatch({
        type: FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_SUCCESS,
        suggestedConditions,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: FETCH_PROFILE_SURVEY_CONDITION_SUGGESTIONS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};
